import { render, staticRenderFns } from "./MainInfo.vue?vue&type=template&id=0024c6da&scoped=true&"
import script from "./MainInfo.vue?vue&type=script&lang=js&"
export * from "./MainInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0024c6da",
  null
  
)

export default component.exports